<template>
  <div class="col-lg-4">
    <div class="card mb-4">
      <h3 class="card-title">{{ $t('common.connection') }}</h3>
      <div class="connection">
        <MaterialSvg
          v-if="error === true"
          class="text-center icon-red"
          name="cancel"
          :width="48"
        />
        <MaterialSvg
          v-else-if="
            error === false && online === true && connectionType === 'wifi'
          "
          class="icon-cyaan"
          name="wifi"
          :width="48"
        />
        <MaterialSvg
          v-else-if="
            error === false && online === false && connectionType === 'wifi'
          "
          class="icon-cyaan"
          name="wifi_off"
          :width="48"
        />
        <MaterialSvg
          v-else-if="
            error === false && online === true && connectionType === 'gprs'
          "
          class="icon-cyaan"
          name="gprs"
          :width="48"
        />
        <MaterialSvg
          v-else-if="
            error === false && online === false && connectionType === 'gprs'
          "
          class="icon-cyaan"
          name="gprs_offline"
          :width="48"
        />
        <MaterialSvg v-else class="icon-cyaan" name="wifi_off" :width="48" />
        <p>{{ isOnline }}</p>
      </div>
      <div class="row">
        <div class="col-12">
          <button
            v-if="online === false"
            @click="openInstructions"
            class="btn btn-primary float-right"
          >
            {{ $t('button.video') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Connection',
  props: {
    online: {
      type: Boolean,
      required: true,
    },
    wifiStrength: {
      type: String,
      default: 'unknown',
    },
    connectionType: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
    },
  },
  computed: {
    isOnline() {
      let msg = 'offline';
      if (this.online) {
        msg = 'online';
      }
      return msg;
    },
  },
  methods: {
    openInstructions() {
      this.$emit('instructions', true);
    },
  },
};
</script>
